import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const SevenChildrenIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 700 200" {...rest} __css={styles}>
      <desc id="svgdescSevenChildrenHungerStats">7 children</desc>
      <circle
        cx="63.5"
        cy="47.9"
        r="19"
        transform="rotate(-31.4 63.5 48)"
        fill="#d05800"
      />
      <path
        d="M74.3 40a2.4 2.4 0 0 1 .5-3c2.9-3 7.2-9.7 13.2-7.9 9.4 2.6 10.1 20 10.1 20s-8.2 2.3-11.5-4.3C82.4 36.6 75.5 40 74.3 40Zm-21 0a2.4 2.4 0 0 0-.5-3c-3-2.9-7.3-9.6-13.4-7.8-9.4 2.7-10 20-10 20s8 2.3 11.5-4.3C45.2 36.6 52 40 53.3 40Zm54.4 63.6L94.5 80.2c-1.3-3.1-6.9-11.5-13.2-11.5H68.7L63.2 85l-5-16.3H47c-6.4 0-12 8.4-13.2 11.5l-13.3 23.4c-1.7 4.2-.2 7.1 2.9 8.4a7 7 0 0 0 8.8-3.9l8.6-13.8-7.3 41.3H48s0 30.1.2 31.2c.4 5.7 4.8 9.4 10.8 9.4h10.1c6 0 10.5-3.7 10.9-9.4.2-1 .2-31.3.2-31.3h14.5l-7.3-41.2 8.6 13.8a7 7 0 0 0 8.8 4c3.1-1.4 4.7-4.3 3-8.5Z"
        fill="#d05800"
      />
      <circle
        cx="160.2"
        cy="47.9"
        r="19"
        transform="rotate(-46 160.2 48)"
        fill="#002d62"
      />
      <path
        d="M201 103.6 190.6 73c-1.2-2-2.2-4-4.7-4.4h-19L160 83l-6.7-14.3h-19c-2.5.3-3.5 2.3-4.7 4.4L119 103.6c-1.7 4.2-.1 7 3 8.4a7 7 0 0 0 8.7-3.9l6.2-17.2-.3 35.7v.2h46.8v-.2l-.3-35.7 6.2 17.2a7 7 0 0 0 8.8 4c3-1.4 4.6-4.3 2.9-8.5Z"
        fill="#002d62"
      />
      <path
        d="M144.5 125.7c0 2.3 0 40 .2 41.1.4 5.7 4.8 9.4 10.8 9.4h10c6 0 10.5-3.7 10.9-9.4.2-1 .2-38.8.2-41.1Z"
        fill="#002d62"
      />
      <circle
        cx="256"
        cy="47.9"
        r="19"
        transform="rotate(-31.4 256 48)"
        fill="#002d62"
      />
      <path
        d="M266.9 40a2.4 2.4 0 0 1 .5-3c2.8-2.9 7.2-9.6 13.3-7.8 9.4 2.6 10 20 10 20s-8 2.3-11.5-4.3c-4.3-8.2-11-4.9-12.3-4.9Zm-21 0a2.4 2.4 0 0 0-.6-3c-2.9-2.9-7.2-9.6-13.3-7.8-9.4 2.6-10.1 20-10.1 20s8.2 2.3 11.6-4.3c4.2-8.2 11-4.9 12.3-4.9Zm54.4 63.6L287 80.2c-1.2-3.1-6.8-11.5-13.2-11.5h-12.5L255.8 85l-5.1-16.3h-11.2c-6.4 0-12 8.4-13.2 11.5L213 103.6c-1.7 4.2-.2 7.1 3 8.4a7 7 0 0 0 8.7-3.9l8.6-13.8-7.2 41.3h14.5s0 30.1.2 31.2c.4 5.7 4.8 9.4 10.8 9.4h10c6 0 10.5-3.7 10.9-9.4.2-1 .2-31.3.2-31.3h14.5L280 94.4l8.6 13.8a7 7 0 0 0 8.8 3.9c3-1.3 4.6-4.2 3-8.4Z"
        fill="#002d62"
      />
      <circle
        cx="352.8"
        cy="47.9"
        r="19"
        transform="rotate(-46 352.8 48)"
        fill="#002d62"
      />
      <path
        d="M393.6 103.6 383.1 73c-1.2-2-2.2-4-4.8-4.4h-19L352.8 83 346 68.7h-19c-2.5.3-3.5 2.3-4.8 4.4l-10.5 30.5c-1.7 4.2-.1 7.1 3 8.4a7 7 0 0 0 8.7-3.9l6.2-17.2-.3 35.7v.2H376v-.2l-.3-35.7 6.1 17.2a7 7 0 0 0 8.8 4c3.1-1.4 4.7-4.3 3-8.5Z"
        fill="#002d62"
      />
      <path
        d="M337 125.7c0 2.3 0 40 .2 41.1.4 5.7 4.8 9.4 10.8 9.4h10.1c6 0 10.4-3.7 10.8-9.4.2-1 .2-38.8.2-41.1Z"
        fill="#002d62"
      />
      <circle
        cx="448.6"
        cy="47.9"
        r="19"
        transform="rotate(-31.4 448.6 48)"
        fill="#002d62"
      />
      <path
        d="M459.4 40a2.4 2.4 0 0 1 .5-3c3-2.9 7.3-9.6 13.4-7.8 9.4 2.6 10 20 10 20s-8.1 2.3-11.5-4.3c-4.3-8.3-11.1-4.9-12.4-4.9Zm-21 0a2.4 2.4 0 0 0-.5-3c-2.9-2.9-7.2-9.6-13.3-7.8-9.4 2.6-10.1 20-10.1 20s8.1 2.3 11.5-4.3c4.3-8.2 11.1-4.9 12.4-4.9Zm54.5 63.6-13.3-23.4c-1.2-3.1-6.8-11.5-13.2-11.5H454L448.4 85l-5.1-16.3H432c-6.4 0-12 8.3-13.2 11.4l-13.3 23.5c-1.7 4.2-.2 7 3 8.4a7 7 0 0 0 8.7-4l8.7-13.7-7.3 41.3h14.5s0 30.1.3 31.2c.4 5.7 4.8 9.4 10.8 9.4h10c6 0 10.4-3.7 10.9-9.4.2-1 .2-31.3.2-31.3h14.5l-7.3-41.2 8.6 13.8a7 7 0 0 0 8.8 3.9c3-1.3 4.6-4.2 2.9-8.4Z"
        fill="#002d62"
      />
      <circle
        cx="545.4"
        cy="47.9"
        r="19"
        transform="rotate(-46 545.4 47.9)"
        fill="#002d62"
      />
      <path
        d="M586.2 103.6 575.7 73c-1.2-2-2.3-4-4.8-4.4h-19L545.2 83l-6.6-14.3h-19c-2.6.3-3.6 2.3-4.8 4.4l-10.5 30.5c-1.8 4.2-.2 7.1 2.9 8.4a7 7 0 0 0 8.8-3.9l6-17.1-.3 35.7v.2h46.9v-.2l-.4-35.7 6.2 17.2a7 7 0 0 0 8.8 3.9c3-1.3 4.6-4.2 3-8.4Z"
        fill="#002d62"
      />
      <path
        d="M529.6 125.7c0 2.3 0 40 .2 41.1.4 5.7 4.8 9.4 10.8 9.4h10.1c6 0 10.4-3.7 10.8-9.4.2-1 .2-38.8.2-41.1Z"
        fill="#002d62"
      />
      <circle
        cx="637.3"
        cy="47.9"
        r="19"
        transform="rotate(-31.5 639.4 48.1)"
        fill="#002d62"
      />
      <path
        d="M648 40a2.4 2.4 0 0 1 .6-3c2.9-2.9 7.2-9.6 13.3-7.8 9.4 2.7 10.1 20 10.1 20s-8.2 2.3-11.6-4.3c-4.2-8.3-11-4.9-12.3-4.9Zm-21 0a2.4 2.4 0 0 0-.5-3c-2.9-2.9-7.2-9.6-13.3-7.8-9.4 2.6-10.1 20-10.1 20s8.1 2.3 11.5-4.3C619 36.6 625.8 40 627 40Zm54.5 63.6-13.3-23.4C667 77 661.5 68.7 655 68.7h-12.5L637 85l-5-16.3h-11.3c-6.4 0-12 8.3-13.2 11.4l-13.3 23.5c-1.7 4.2-.1 7 3 8.4a7 7 0 0 0 8.7-4l8.7-13.7-7.3 41.2h14.5s0 30.2.2 31.3c.4 5.6 4.8 9.3 10.8 9.3H643c6 0 10.4-3.7 10.8-9.3.2-1.1.2-31.3.2-31.3h14.6l-7.3-41.2 8.6 13.8a7 7 0 0 0 8.8 3.9c3-1.3 4.6-4.2 3-8.4Z"
        fill="#002d62"
      />
    </Icon>
  );
};

export default SevenChildrenIcon;
